import React from 'react';
import { StyledDataGrid, DataGridProps, } from 'custom/components';
import { Box, Grid, Skeleton, Stack, Typography, } from '@mui/material';
import flightStyles from './fltloadinfo.module.css';
import styles from '../../../../../custom/style.module.css';
import { grey } from '@mui/material/colors';

const roundNumber = (num) => {
  // return parseFloat(num).toFixed(2);
  let int = parseInt(num, 10);
  return Math.round(int*100)/100;
};

// const getFlightStatiscics = (data) => { //data type 1
//   console.log('billingColumns', data);
//   //inbound counts for finalized_flights, pending_flights, rejected_flights, accountant_flights, airlinerep_flights
//   //outbound counts for finalized_flights, pending_flights, rejected_flights, accountant_flights, airlinerep_flights
//   if (data && data.length > 0 ) {
//     return data.map((airline) => {
//       const inbound = airline.inbound?.flights || [];
//       const outbound = airline.outbound?.flights || [];
//       const inboundCount = inbound.reduce((acc, flight) => {
//         acc.finalized_flights += flight.reports?.filter(report => report.status === 'Finalized').length || 0;
//         acc.pending_flights += flight.reports?.filter(report => report.status === null || report.status === '').length || 0;
//         acc.rejected_flights += flight.reports?.filter(report => report.status === 'Rejected').length || 0;
//         acc.accountant_approved_flights += flight.reports?.filter(report => report.status === 'Pending' && report.approved_acc === true).length || 0;
//         acc.airlinerep_approved_flights += flight.reports?.filter(report => report.status === 'Approved' && report.approved_air === true).length || 0;
//         return acc;
//       }, {
//         finalized_flights: 0,
//         pending_flights: 0,
//         rejected_flights: 0,
//         accountant_approved_flights: 0,
//         airlinerep_approved_flights: 0
//       });

//       const outboundCount = outbound.reduce((acc, flight) => {
//         acc.finalized_flights += flight.reports?.filter(report => report.status === 'Finalized').length || 0;
//         acc.pending_flights += flight.reports?.filter(report => report.status === null || report.status === '').length || 0;
//         acc.rejected_flights += flight.reports?.filter(report => report.status === 'Rejected').length || 0;
//         acc.accountant_approved_flights += flight.reports?.filter(report => report.status === 'Pending' && report.approved_acc === true).length || 0;
//         acc.airlinerep_approved_flights += flight.reports?.filter(report => report.status === 'Approved' && report.approved_air === true).length || 0;
//         return acc;
//       }, {
//         finalized_flights: 0,
//         pending_flights: 0,
//         rejected_flights: 0,
//         accountant_approved_flights: 0,
//         airlinerep_approved_flights: 0
//       });

//       return {
//         inbound: { ...inboundCount },
//         outbound: { ...outboundCount },
//       };
//     });
//   }
//   return [];
// };

const getFlightStatiscics = (data) => { //data type 2
  if (data && data.length > 0) {
    // Aggregate counts for all airlines
    let finalized_flights = { 
      inbound: 0,
      outbound: 0
    };
    let pending_flights = { 
      inbound: 0, 
      outbound: 0 
    };
    let rejected_flights = { 
      inbound: 0, 
      outbound: 0 
    };
    let accountant_approved_flights = { 
      inbound: 0, 
      outbound: 0 
    };
    let airlinerep_approved_flights = { 
      inbound: 0, 
      outbound: 0 
    };

    data.forEach((airline) => {
      const inbound = airline.inbound?.flights || [];
      const outbound = airline.outbound?.flights || [];

      inbound.forEach(flight => {
        finalized_flights.inbound += flight.reports?.filter(report => report.status === 'Finalized').length || 0;
        pending_flights.inbound += flight.reports?.filter(report => report.status === null || report.status === '').length || 0;
        rejected_flights.inbound += flight.reports?.filter(report => report.status === 'Rejected').length || 0;
        accountant_approved_flights.inbound += flight.reports?.filter(report => report.status === 'Pending' && report.approved_acc === true).length || 0;
        airlinerep_approved_flights.inbound += flight.reports?.filter(report => report.status === 'Approved' && report.approved_air === true).length || 0;
      });

      outbound.forEach(flight => {
        finalized_flights.outbound += flight.reports?.filter(report => report.status === 'Finalized').length || 0;
        pending_flights.outbound += flight.reports?.filter(report => report.status === null || report.status === '').length || 0;
        rejected_flights.outbound += flight.reports?.filter(report => report.status === 'Rejected').length || 0;
        accountant_approved_flights.outbound += flight.reports?.filter(report => report.status === 'Pending' && report.approved_acc === true).length || 0;
        airlinerep_approved_flights.outbound += flight.reports?.filter(report => report.status === 'Approved' && report.approved_air === true).length || 0;
      });
    });

    return {
      finalized_flights,
      pending_flights,
      rejected_flights,
      accountant_approved_flights,
      airlinerep_approved_flights
    };
  }
  return {
    finalized_flights: { 
      inbound: 0, 
      outbound: 0 
    },
    pending_flights: { 
      inbound: 0, 
      outbound: 0 
    },
    rejected_flights: { 
      inbound: 0, 
      outbound: 0 
    },
    accountant_approved_flights: { 
      inbound: 0, 
      outbound: 0 
    },
    airlinerep_approved_flights: { 
      inbound: 0, 
      outbound: 0 
    }
  };
};

const Statistics = (props) => {
  const { summaryData, billingColumns, showSummary } = props;
  const billingData = getFlightStatiscics(props.billingData);
  console.log('billingData1111', billingData);
  const summaryProps = {
    variant: 'body2',
    component: 'small',
    color: grey[800],
    fontSize: 13,
  };

  const summaryMainProps = {
    variant: 'body1',
    component: 'p',
    color: 'primary',
    fontWeight: 600,
    fontSize: '0.9rem',
  };

  return <>
    <Grid container spacing={3} className={styles.pt1}>
      { billingColumns && billingColumns.length > 0 ? showSummary && billingColumns.map((column, index) => {
        return <Grid item sm={12} md={6} lg={4} xl={3} key={index}>
          <div className={flightStyles.summaryCard}>
            <div className={`${styles.fStartSpaceBtw} ${styles.pb2}`}>
              <Typography {...summaryMainProps}>{column.headerName}</Typography>
              <Typography {...summaryMainProps}>{roundNumber(summaryData[column.field])}</Typography>
            </div>
            <div className={`${styles.fSpaceBtw} ${styles.mtauto} ${styles.pt2} ${flightStyles.summaryHead}`}>
              <Stack direction='column'>
                <Typography {...summaryProps}>Inbound</Typography>
                <Typography {...summaryProps}>{summaryData.inbound && roundNumber(summaryData.inbound[column.field]) || 0 }</Typography>
              </Stack>
              <Stack direction='column'>
                <Typography {...summaryProps}>Outbound</Typography>
                <Typography {...summaryProps} textAlign='right'>{ summaryData.outbound && roundNumber(summaryData.outbound[column.field]) || 0}</Typography>
              </Stack>
            </div>
          </div>
        </Grid>;
      }) : Array.from({ length: 9 }).map((_, index) => <Grid item sm={12} md={6} lg={4} xl={3} key={index}>
        <Skeleton variant='rectangular' width={'100%'} height={100} /> 
      </Grid>)
      }
    </Grid>
    
    {!showSummary &&
    <div className={`${styles.tableWrapper} ${styles.pt2}`}>
      <Box className={`${styles.tableOuter} ${flightStyles.statTableOuter} ${styles.mt3}`}>
        <StyledDataGrid
          {...DataGridProps}
          rows={props?.contractData || []}
          columns={props.billingCol || []}
          // apiRef={props.apiRef}
          param={props.contractData?.length}
        />
      </Box>
    </div>
    }
  </>;
};

export default Statistics;